(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oryn-privacy-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-cookie-preferences]') : null;
    if (!button || button.disabled) return;
    const status = button.closest('.oryn-privacy-links')?.querySelector('[data-cookie-preferences-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = '';
      status.hidden = true;
    }
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Cookie preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) {
        status.textContent = 'Cookie preferences could not open. Reload and try again, or contact contact@karvanis.be for help.';
        status.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
